import React, { useEffect, useState } from 'react'
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import styled from 'styled-components';
import CountUp from 'react-countup';

import { IProgram } from '../../../types/program';
import { IScoreHypo } from '../../../types/scoreHypo';
import { IUserInfo } from '../../../types/user';

import qualify from '../../../images/qualify.png';
import { ImageAsset } from '../../wrappers/ImageAsset';

export interface IProgramResultProps {
    program: IProgram;
    hyposList: IScoreHypo[];
    applicant: string;
    user: IUserInfo | null;
};

const OuterStatus = styled.div`
  width: 228px;
  height: 228px;
  margin: auto;
  & p {
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    padding-bottom: 25px;
    margin-top: -15px;
  }
  & span {
    font-weight: 700;
    letter-spacing: -2.344px;
    font-size: 75px;
    color: ${({ color }) => color};
  }
`;

const getScoreColour = (score: number, draw: any) => {
    let color = '#FF4040'
    if (Number(score) >= Number(draw?.draw_points)) {
        color = '#39B54A'
    } else if (Number(draw?.draw_points) - Number(score) < 100) {
        color = '#FF9540'
    }
    return color
}

const ProgramResult = ({ program, hyposList, applicant, user }: IProgramResultProps) => {

    const currentDate = new Date()
    const [color, seColor] = useState('#FF9540');
    const [scoreDetails, setScoreDetails] = useState<any>(null);
    const [draw, setDraw] = useState<any>(null);
    const [scoreHypos, setScoreHypos] = useState<IScoreHypo[]>([]);


    useEffect(() => {
        if (applicant && user && program) {
            const scenario = applicant === "main" ? (user.spouseScore.length ? "married" : "single") : (user.applicantScore.length ? "married" : "single")
            const sd = applicant === "main" ? user.applicantScore.find((item) => item?.scenario?.scenario === scenario) : user.spouseScore.find((item) => item?.scenario?.scenario === scenario)
            setScoreDetails(sd);
            const draw = program?.results.find((item) => item.scenario_id === sd?.scenario_id)
            seColor(getScoreColour(sd?.score ?? 0, draw))
            setDraw(draw)
        }
    }, [applicant, user, program])


    useEffect(() => {
        if (hyposList) {
            const hypos = hyposList.filter(hypo => hypo.score >= (draw?.draw_points ?? 0));
            setScoreHypos(hypos);
        }

    }, [hyposList, scoreDetails, draw])

    if (program?.group !== "express-entry") {
        return (
            <div className='imm_program_result__main'>
                <div className="imm_program_result__hypos">
                    <div className="imm_program_result__card">
                        <h4>{program.name}</h4>
                        <h5>{program.description}</h5>
                        <div className="imm_program_row">
                            <a href={program?.gov_url ?? '/#'} target="_blank" rel="noreferrer" className="link-button">Learn more</a>
                            <button className="primary-button">Book Consult</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className='imm_program_result__main'>
            <div className="imm_program_result__score">
                <OuterStatus className='outerStatus' color={color}>
                    <CircularProgressbarWithChildren
                        value={(Number(scoreDetails?.score ?? 0) / (draw ? Number(draw?.draw_points) : 1200)) * 100}
                        strokeWidth={5}
                        styles={buildStyles({
                            pathTransitionDuration: 1,
                            trailColor: '#AEC3ED',
                            pathColor: color,
                        })}
                    >
                        <p>{applicant === "main" ? user?.applicant.first_name : user?.spouse.first_name}'s Score is</p>
                        <CountUp end={scoreDetails?.score ?? 0} duration={1} />
                    </CircularProgressbarWithChildren>
                </OuterStatus>
                <p className="imm_program_result_recent_draw">Recent draw {new Date(draw?.draw_date || currentDate).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                })}<br /> <span>{draw?.draw_points ?? 0} points</span></p>
            </div>

            {color === '#39B54A' ?
                <h5 className="imm_program_result__recommendation">{applicant === "main" ? user?.applicant.first_name : user?.spouse.first_name} qualify for immigration to Canada <ImageAsset src={qualify} style={{ marginLeft: 5, verticalAlign: "middle" }} alt="" /></h5> :
                <h5 className="imm_program_result__recommendation">Recommendations</h5>
            }

            {/* {
                color === '#39B54A'
                    ? null
                    : <div className='imm__score_projection_note'>
                        <BsExclamationCircle />
                        <span>We don't consider your age increasing.</span>
                    </div>
            } */}

            {/* {
                color === '#39B54A'
                    ? null
                    : <div className='imm__want_more_options_note'>
                        <div className='imm__want_more_options__left'>
                            <h4 className='color_primary'>Want more options?</h4>
                            <p className='mice'>These are just a few recommendations. For a comprehensive view speak to one of our experts</p>
                            <a href='/book-consult'>Book&nbsp;Consult</a>
                        </div>
                        <div className='imm__want_more_options__right'>
                            <ImageAsset className='fit_asset_max' src={Images.WantMoreOptions} alt='' />
                        </div>
                    </div>
            } */}

            {/* <div className="imm_program_result__hypos">
                {color !== '#39B54A' && scoreHypos.map((item, key) => <div key={key} className="imm_program_result__card">
                    <h3>{item.score}pts. (difficulty - {item.difficulty})</h3>
                    {item.grouped_score_hypos.map((gsc, idx) => <ul key={idx}>
                        <li>{gsc.description}</li>
                    </ul>)}
                </div>)}
            </div> */}

            {
                color === '#39B54A'
                    ? null
                    : scoreHypos?.length
                        ? scoreHypos.map((scoreHypoGroup, idx) => {
                            const difficulty =
                                scoreHypoGroup.difficulty === 1
                                    ? 'easier'
                                    : scoreHypoGroup.difficulty === 2
                                        ? 'medium'
                                        : 'hard';

                            return (
                                <div className='imm__score_hypo_card' key={idx}>
                                    <div className='imm__shc__top'>
                                        <div className='imm__shc__score'>
                                            {scoreHypoGroup.score}pts.
                                            {/* (difficulty - {item.difficulty}) */}
                                        </div>
                                        <div className={`imm__shc__difficulty imm__shc__d__${difficulty}`}>
                                            <div className='imm__shc__dots'>
                                                <span /><span /><span />
                                            </div>
                                            <span className='imm__shc__difficulty_title'>
                                                {difficulty[0].toUpperCase() + difficulty.slice(1)}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='imm__shc__hypo_content'>
                                        {scoreHypoGroup.grouped_score_hypos.map((groupdScoreHypo, idx2) =>
                                            <div className='imm__shc__hypo_content_bullet' key={idx2}>
                                                <div className='imm__shc__hypo_content__dot' />
                                                <span className='mice'>{groupdScoreHypo.description}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })
                        : null

                // <div style={{ margin: '30px auto', display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 20 }}>
                //   <span style={{ fontWeight: 600, textAlign: 'center' }}>
                //     No recommendations at this point!
                //   </span>
                // </div>
            }

            {/* {
                color === '#39B54A'
                    ? null
                    : <div className='imm__speak_to_us_note'>
                        <p className='mice'>Learn more, speak to us today!</p>
                        <a href='/book-consult'>Book&nbsp;Consult</a>
                    </div>
            } */}

        </div>
    );
}
export default ProgramResult;